import _ from "underscore";
import React, { ReactElement } from "react";

const caretDown = require("../svg/caretDown.svg");
interface NavGroupProps extends React.PropsWithChildren {
  badgeCounts?: number[];
  expandedId: string;
  groupId: string;
  icon?: string;
  iconSvg?: ReactElement;
  label: string;
  location: string;
  navigationShrunk: boolean;
  onClick: any;
  onInitialLoad: any;
}

export default class NavGroup extends React.Component<NavGroupProps, any> {
  static defaultProps = {
    expandedId: null,
    badgeCounts: [],
  };

  componentDidMount() {
    const children = Array.isArray(this.props.children) ? this.props.children : [this.props.children]

    if (this.getUrls(children)?.includes(this.props.location)) {
      this.props.onInitialLoad(this.props.groupId);
    }

    this.getPrefixes(children)?.forEach((prefix) => {
      if (this.props.location.startsWith(prefix)) {
        this.props.onInitialLoad(this.props.groupId);
      }
    });
  }

  render() {
    const hasBadgeCounts = _.some(this.props.badgeCounts, (n: number) => {
      return n > 0;
    });

    return (
      <div
        className={this.getClasses()}
        id={`link-group-${this.props.groupId}`}
      >
        <div onClick={this.handleClick} className={this.getBadgedClasses()}>
          {this.props.iconSvg ? (
            this.props.iconSvg
          ) : (
            <i className={this.props.icon} />
          )}
          <span className="text">{this.props.label}</span>
          <div className="menu-caret">
            <img src={caretDown} />
          </div>
          {hasBadgeCounts && <div className="badge-circle" />}
        </div>
        <div className="links">{this.props.children}</div>
      </div>
    );
  }

  getBadgedClasses = () => {
    if (
      _.some(this.props.badgeCounts, (n: number) => {
        return n > 0;
      })
    ) {
      return "name badged";
    }
    return "name";
  };

  handleClick = () => {
    this.props.onClick(this.props.groupId);
  };

  getClasses = () => {
    if (
      this.props.groupId === this.props.expandedId &&
      !this.props.navigationShrunk
    ) {
      return "link-group expanded";
    }

    return "link-group";
  };

  getUrls = (children: any[]) => {
    return children.map((child) => {
      if (child) {
        if (child.props.selectedUrlPrefix) {
          return null;
        }
        return this.convertUrl(child.props.url);
      }

      return null;
    });
  };

  getPrefixes = (children: any[]) => {
    return children.map((child) => {
      if (child) {
        if (child.props.selectedUrlPrefix) {
          return child.props.selectedUrlPrefix;
        }
        return null;
      }

      return null;
    });
  };

  convertUrl = (url: string) => {
    return url.split("?")[0];
  };
}
